import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { MEEM_BLOCKS } from '../lib/meemItems';

const EDUCACAO = ['Sem escolaridade', '1 a 4 anos', '5 a 8 anos', '9 a 11 anos', '12 anos ou mais'];

/**
 * Ficha de registro EM BRANCO, para preencher à mão durante a aplicação.
 * Não reproduz o formulário do MMSE (instrumento licenciado): traz só a estrutura do
 * protocolo brasileiro (blocos e pontuação máxima, de meemItems.js) e campos de registro.
 * Renderizada em portal no <body> com id "folha-impressao" para a regra @media print
 * de index.css imprimir só a ficha, em uma página A4.
 */
function Ficha() {
  const linha = 'border-b border-black pb-1';
  return (
    <div id="folha-impressao" className="hidden print:block text-black">
      <header className="border-b-2 border-black pb-2 mb-3">
        <h1 className="text-lg font-bold text-black leading-tight">Ficha de registro do Mini Exame do Estado Mental (MEEM)</h1>
        <p className="text-[10px] leading-snug mt-1">Registro de aplicação · Instrumento de rastreio cognitivo · Não estabelece diagnóstico</p>
      </header>

      <section className="grid grid-cols-2 gap-x-8 gap-y-2 text-[11px] mb-3">
        <div className={linha}>Paciente:</div>
        <div className={linha}>Registro / prontuário:</div>
        <div className={linha}>Data de nascimento: ___/___/______</div>
        <div className={linha}>Data da aplicação: ___/___/______</div>
        <div className={linha}>Aplicador:</div>
        <div className={linha}>Conselho / registro profissional:</div>
      </section>

      <section className="text-[11px] mb-3">
        <p className="font-bold mb-1">Escolaridade (anos completos de estudo)</p>
        <p>{EDUCACAO.map((e) => `( ) ${e}`).join('     ')}</p>
      </section>

      <section className="mb-3">
        <table className="w-full border-collapse text-[11px]">
          <thead>
            <tr>
              <th className="border border-black px-2 py-1 text-left">Bloco</th>
              <th className="border border-black px-2 py-1 w-24 text-center">Pontos</th>
              <th className="border border-black px-2 py-1 text-left">Anotações da aplicação</th>
            </tr>
          </thead>
          <tbody>
            {MEEM_BLOCKS.map((b) => (
              <tr key={b.id}>
                <td className="border border-black px-2 py-2">{b.label}</td>
                <td className="border border-black px-2 py-2 text-center">___ / {b.max}</td>
                <td className="border border-black px-2 py-2"></td>
              </tr>
            ))}
            <tr>
              <td className="border border-black px-2 py-2 font-bold">Total</td>
              <td className="border border-black px-2 py-2 text-center font-bold">___ / 30</td>
              <td className="border border-black px-2 py-2"></td>
            </tr>
          </tbody>
        </table>
      </section>

      <section className="mb-3">
        <p className="text-[11px] font-bold uppercase tracking-wide mb-1">Condições da aplicação</p>
        <div className="grid grid-cols-2 gap-x-8 gap-y-2 text-[11px] mb-2">
          <div className={linha}>Óculos / aparelho auditivo habituais:</div>
          <div className={linha}>Ambiente e interrupções:</div>
          <div className={linha}>Dor, fadiga, sonolência ou agitação:</div>
          <div className={linha}>Medicações relevantes:</div>
        </div>
        <div className={`${linha} text-[11px] h-10`}>Observações clínicas:</div>
      </section>

      <section className="border border-black p-2 text-[9px] leading-snug mb-3">
        <strong>O que este número não estabelece.</strong> O MEEM é rastreio. A pontuação isolada não confirma nem exclui
        comprometimento cognitivo e deve ser lida junto com escolaridade, déficit sensorial, delirium, depressão, dor,
        fadiga, medicações e perda funcional em relação ao nível prévio da pessoa.
      </section>

      <footer className="border-t border-black pt-1 text-[8px] leading-snug flex justify-between gap-6">
        <p className="max-w-[70%]">
          Estrutura conforme Brucki SMD, Nitrini R, Caramelli P, Bertolucci PHF, Okamoto IH. Sugestões para o uso do
          Mini-Exame do Estado Mental no Brasil. Arq Neuropsiquiatr. 2003;61(3-B):777-781. doi:10.1590/S0004-282X2003000500014.
          Ficha de registro própria; não é o formulário oficial do MMSE nem versão licenciada.
        </p>
        <p className="text-right shrink-0">minimental.com.br<br />Assinatura: ______________________</p>
      </footer>
    </div>
  );
}

export default function FichaEmBranco() {
  const [montado, setMontado] = useState(false);
  useEffect(() => setMontado(true), []);
  return (
    <>
      <button type="button" onClick={() => window.print()} className="btn-primary text-center no-print">
        Imprimir ficha de registro (PDF em branco)
      </button>
      {montado && createPortal(<Ficha />, document.body)}
    </>
  );
}
